/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowAssigneeDtoSchema } from "./dealflowAssigneeDtoSchema.ts";
import { dealflowBlockerDtoSchema } from "./dealflowBlockerDtoSchema.ts";
import { dealflowCompletenessCheckDtoSchema } from "./dealflowCompletenessCheckDtoSchema.ts";
import { dealflowContactDtoSchema } from "./dealflowContactDtoSchema.ts";
import { dealflowDecisionEntryDtoSchema } from "./dealflowDecisionEntryDtoSchema.ts";
import { dealflowDeckDtoSchema } from "./dealflowDeckDtoSchema.ts";
import { dealflowEnrichmentInfoDtoSchema } from "./dealflowEnrichmentInfoDtoSchema.ts";
import { dealflowExtractedDtoSchema } from "./dealflowExtractedDtoSchema.ts";
import { dealflowInvestmentNeedDtoSchema } from "./dealflowInvestmentNeedDtoSchema.ts";
import { dealflowPitchDeckDtoSchema } from "./dealflowPitchDeckDtoSchema.ts";
import { dealflowRejectedInfoDtoSchema } from "./dealflowRejectedInfoDtoSchema.ts";
import { dealflowRejectionDetailDtoSchema } from "./dealflowRejectionDetailDtoSchema.ts";
import { dealflowTeamInfoDtoSchema } from "./dealflowTeamInfoDtoSchema.ts";
import { dealflowTractionDtoSchema } from "./dealflowTractionDtoSchema.ts";
import { dealflowVerifiedInfoDtoSchema } from "./dealflowVerifiedInfoDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowRowDtoSchema = z.object({
  id: z.optional(z.string()),
  startupName: z.optional(z.string()),
  disposition: z.optional(z.string()),
  rejectionSource: z.optional(z.string()),
  processingStage: z.string().nullish(),
  funnelStage: z.optional(z.string()),
  justification: z.string().nullish(),
  get extracted() {
    return dealflowExtractedDtoSchema.nullish();
  },
  createdAt: z.optional(z.iso.datetime()),
  isDemo: z.optional(z.boolean()),
  domain: z.string().nullish(),
  score: z.number().nullish(),
  action: z.string().nullish(),
  get assignee() {
    return dealflowAssigneeDtoSchema.nullish();
  },
  get blockers() {
    return z.array(dealflowBlockerDtoSchema).nullish();
  },
  get decisions() {
    return z.array(dealflowDecisionEntryDtoSchema).nullish();
  },
  get rejection() {
    return dealflowRejectionDetailDtoSchema.nullish();
  },
  get contact() {
    return dealflowContactDtoSchema.nullish();
  },
  trl: z.int().nullish(),
  incorporatedIn: z.int().nullish(),
  productType: z.string().nullish(),
  get traction() {
    return dealflowTractionDtoSchema.nullish();
  },
  get investmentNeed() {
    return dealflowInvestmentNeedDtoSchema.nullish();
  },
  get team() {
    return dealflowTeamInfoDtoSchema.nullish();
  },
  get completeness() {
    return dealflowCompletenessCheckDtoSchema.nullish();
  },
  get enrichmentInfo() {
    return dealflowEnrichmentInfoDtoSchema.nullish();
  },
  get verifiedInfo() {
    return dealflowVerifiedInfoDtoSchema.nullish();
  },
  get rejectedInfo() {
    return dealflowRejectedInfoDtoSchema.nullish();
  },
  elevatorPitch: z.string().nullish(),
  get pitchDeck() {
    return dealflowPitchDeckDtoSchema.nullish();
  },
  get deck() {
    return dealflowDeckDtoSchema.nullish();
  },
});
